import React from 'react';
import { EXIT_REASON_LABELS } from '../../../constants';
import type { DripExitReason } from '../../../types';
import * as styles from './journey.module.css';
const ExitCard: React.FC<{ reason?: DripExitReason }> = ({ reason }) => (
    <div className={styles.finish}>
        <span className={styles.finishIcon} aria-hidden="true">
            ✓
        </span>
        <div>
            <strong>Finish</strong>
            {reason && <p>{EXIT_REASON_LABELS[reason] ?? reason}</p>}
        </div>
    </div>
);
export default ExitCard;
